import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { FaEdit } from "react-icons/fa";
import { MdDelete, MdOutlineAdd } from "react-icons/md";
import axios from "axios";

function RegisterStudents() {
  const [selectedStage, setSelectedStage] = useState("");
  const [students, setStudents] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await axios.get(
          "https://iop.liba.edu/liba/restapi/admin/getuserdetails/"
        );

        const result = response.data?.data || [];

        const formattedData = result.map((data) => ({
          id: data.id, // assuming there's an ID field
          StudentName: data.username || "N/A",
          StudentMail: data.email || "N/A",
          StudentPhone: data.phone || "N/A",
          StudentCourse: "PGDM",
          StudentStatus: data.sp_status == 1 ? "Active" : "Inactive",
          amount: data.amount,
          date: data.cdate?.split(" ")[0] || "N/A",
          stage: data.user_stage || "N/A",
        }));

        setStudents(formattedData);
      } catch (error) {
        console.error("Error fetching student data:", error);
        setStudents([]);
      }
    };

    fetchStudents();
  }, []);

  const openDeleteModal = (student) => {
    setStudentToDelete(student);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setStudentToDelete(null);
    setIsDeleteModalOpen(false);
  };

  const handleDelete = async () => {
    if (!studentToDelete) return;

    try {
      await axios.delete(
        `https://iop.liba.edu/liba/restapi/admin/deleteuser/?id=${studentToDelete.id}`
      );

      setStudents((prevStudents) =>
        prevStudents.filter((student) => student.id !== studentToDelete.id)
      );

      closeDeleteModal();
    } catch (error) {
      console.error("Failed to delete student:", error);
      alert("Failed to delete student. Please try again.");
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px",
    },
    {
      name: "Name",
      selector: (row) => row.StudentName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.StudentMail,
      sortable: true,
    },
    {
      name: "Phone No",
      selector: (row) => row.StudentPhone,
      sortable: true,
    },
    {
      name: "Course Name",
      selector: (row) => row.StudentCourse,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.StudentStatus,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <FaEdit style={{ cursor: "pointer" }} />
          <MdDelete
            style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
            onClick={() => openDeleteModal(row)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="department">
      <div className="row">
        <div className="col-lg-10 mb-3 mt-3">
          <h3>Register Students Details</h3>
        </div>
        <div className="col-lg-2 mt-3">
          <button
            style={{
              backgroundColor: "green",
              color: "white",
              borderRadius: "10px",
              padding: "5px 10px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            Add <MdOutlineAdd style={{ fontSize: "18px" }} />
          </button>
        </div>

        <div className="col-lg-12">
          <DataTable
            columns={columns}
            data={students.filter((row) =>
              selectedStage === "" ? true : row.stage.toString() === selectedStage
            )}
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
            responsive
            highlightOnHover
            striped
            noDataComponent={<div>No data available</div>}
          />
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              width: "300px",
              textAlign: "center",
            }}
          >
            <h4>Are you sure you want to delete?</h4>
            <p>
              Student: <strong>{studentToDelete?.StudentName}</strong>
            </p>
            <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-around" }}>
              <button
                style={{
                  padding: "8px 16px",
                  backgroundColor: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={handleDelete}
              >
                Delete
              </button>
              <button
                style={{
                  padding: "8px 16px",
                  backgroundColor: "gray",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={closeDeleteModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RegisterStudents;
